import { Component, inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { finalize, switchMap } from 'rxjs'
import { BaseComponent } from '../../../../common/components/base.component'
import { MfaService } from '../../../../common/services/mfa/mfa.service'
import { AuthService } from '../../../../common/services/auth.service'
import { OrderRoutes } from '../../../orders/orders-routes.enum'

@Component({
  selector: 'app-totp-verify',
  templateUrl: './totp-verify.component.html',
  styleUrl: './totp-verify.component.scss',
  standalone: false
})
export class TotpVerifyComponent extends BaseComponent {

  #mfaService = inject(MfaService)
  #authService = inject(AuthService)
  #spinnerId = 'mfa-spinner'

  codeForm = new FormGroup({
    code: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6}$')])
  })
  errorMessage = ''

  onValidate(): void {
    if (!this.codeForm.valid) {
      return
    }
    this.errorMessage = ''
    this.spinnerService.setLoading(true, this.#spinnerId)

    this.subscriptions.add(this.#mfaService.totpValidate(String(this.codeForm.value.code))
      .pipe(
        switchMap(() => this.#authService.getWelcomeInfo()),
        finalize(() => this.spinnerService.setLoading(false, this.#spinnerId))
      )
      .subscribe({
        next: () => {
          let route: string = OrderRoutes.WELCOME;
          if (this.featureFlagService.isLICProcessEnabled()) {
            const launchId = this.launchAuthRedirectService.getPendingLaunchId();
            if (launchId) {
              route = 'auth/lic'
            }
          }
          this.router.navigate([route])
        },
        error: () => this.errorMessage = 'Invalid code. Please try again.'
      }))
  }

  onBackClicked(): void {
    this.router.navigate(['/mfa/selection'])
  }
}
